import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthenticationGuard } from "app/services/authentication-guard.service";
import { ClientComponent } from "app/client/client.component";
import { CallCreateModule } from "app/client/call/create/call-create.module";
import { CallCreateComponent } from "app/client/call/create/call-create.component";
import { CallsComponent } from "app/client/call/list/calls.component";
import { ProfileModule } from "app/client/profile/profile.module";
import { ProfileComponent } from "app/client/profile/profile.component";
import { CallDetailsComponent } from "app/client/call/details/call-details.component";
import { ServiceObjectMapComponent } from "app/client/serviceObject/map/service-object-map.component";
import { LocationListComponent } from "app/client/serviceObject/location/list/location-list.component";
import { AssetListComponent } from "app/client/serviceObject/asset/list/asset-list.component";
import { ServiceObjectDetailsComponent } from "app/client/serviceObject/location/details/service-object-details.component";
import { PlannedServiceListComponent } from "app/client/plannedService/list/plannedService-list.component";
import { PlannedServiceDetailsComponent } from "app/client/plannedService/details/plannedService-details.component";
import { UserListComponent } from "./admin/user/list/user-list.component";
import { User } from "app/models/user";

const clientRoutes: Routes = [
  {
    path: "",
    component: ClientComponent,
    canActivate: [AuthenticationGuard],
    canActivateChild: [AuthenticationGuard],
    children: [
      { path: "", pathMatch: "full", redirectTo: "call/list" },
      { path: "call/list", component: CallsComponent },
      { path: "serviceObject/:id/assets", component: AssetListComponent },
      { path: "serviceObject/list", component: LocationListComponent },
      { path: "plannedService/list", component: PlannedServiceListComponent },
      { path: "serviceObject/map", component: ServiceObjectMapComponent },
      { path: "call/create", component: CallCreateComponent },
      { path: "serviceObject/:id", component: ServiceObjectDetailsComponent },
      { path: "call/:id/:tab", component: CallDetailsComponent },
      { path: "call/:id", component: CallDetailsComponent },
      { path: "plannedService/:id", component: PlannedServiceDetailsComponent },
      { path: "profile", component: ProfileComponent },
      { path: 'admin/list', component: UserListComponent, data: { role: User.Role.Administrator } },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(clientRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ClientRoutingModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/client-routing.module.ts